import clsx from "clsx"
import { skeleton } from "src/components/skeletons/skeletonStyles"
import { localizeText } from "src/localization/utils"
import { StorefrontDetailProduct, StorefrontDetailVariant } from "src/types/storefront"
import { isDummyVariant } from "src/utilities/product"

export type ProductPriceProps = {
  product: StorefrontDetailProduct
  variant: StorefrontDetailVariant | undefined
}

export function ProductPrice({ product, variant }: ProductPriceProps) {
  const initializing = !variant
  const pricing = variant?.pricing || product.variants[0]?.pricing

  if (!initializing && !pricing) {
    return <div className={clsx(skeleton.invisible, "block h-11 w-full animate-pulse bg-gray-100")} />
  }

  const T = localizeText(text)

  return (
    <div className="flex flex-wrap justify-between gap-2 font-semibold">
      <div className="flex flex-wrap justify-end gap-x-1">
        <span className="whitespace-nowrap">{product.title}</span>
        {variant && !isDummyVariant(variant) && <span className="whitespace-nowrap">({variant.name})</span>}
      </div>

      <div className="flex gap-2">
        {!variant && (product.variants?.length || 0) > 1 && T.from + " "}

        {pricing?.type === "sale" && pricing.calculatedPriceFormatted !== pricing.originalPriceFormatted && (
          <span className="text-muted line-through">{pricing.originalPriceFormatted}</span>
        )}

        <span
          className={clsx({
            "text-discount font-medium": pricing?.type === "sale",
          })}
        >
          {pricing?.calculatedPriceFormatted}
        </span>
      </div>
    </div>
  )
}

const de = {
  from: "ab",
}

const en: typeof de = {
  from: "from",
}

const text = { de, en }
